import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../layout/Layout'
import InvoiceSvg from '../other/svg/InvoiceSvg'
import ImportDocumentForm from '../molecules/ImportDocumentForm'
import {
  FETCH_INITIAL_IMPORT_DOCUMENT_VALUES,
  RESET_IMPORT_DOCUMENT_PDF,
  UPDATE_IMPORT_DOCUMENT
} from 'src/redux/importDocumentReducer'
import { RootReducer } from 'src/redux/rootReducer'

interface UrlParams {
  clientId: string
  importDocumentId: string
  [key: string]: string | undefined
}

const ImportDocumentUpdate = (): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { clientId, importDocumentId } = useParams<UrlParams>()
  const loading = useSelector((state: RootReducer) => state.importDocumentReducer.loading)
  const importDocumentPdf = useSelector((state: RootReducer) => state.importDocumentReducer.import_document_pdf)

  useEffect(() => {
    return () => {
      dispatch(RESET_IMPORT_DOCUMENT_PDF())
    }
  }, [dispatch])

  useEffect(() => {
    dispatch(FETCH_INITIAL_IMPORT_DOCUMENT_VALUES({ id: importDocumentId ?? '' }))
  }, [dispatch, importDocumentId])

  useEffect(() => {
    if (importDocumentPdf !== null) {
      window.open(importDocumentPdf, '_blank')
      navigate(`/selling/clients/${clientId ?? ''}`)
    }
  }, [importDocumentPdf, navigate, clientId])

  const handleSubmit = (values: any): void => {
    dispatch(UPDATE_IMPORT_DOCUMENT({ values, id: importDocumentId ?? '' }))
  }

  const handleCancel = (): void => {
    navigate(`/selling/clients/${clientId ?? ''}`)
  }

  const initialFormValues = useSelector((state: RootReducer) => {
    return state.importDocumentReducer.initialImportDocumentValues[importDocumentId ?? ''] ?? null
  })

  return (
    <Layout
      name="import-document-update"
      iconComponent={<InvoiceSvg className="w-8 h-8 text-white" />}
      withFiler={false}
      withoutToolbar={false}>
      <div className="h-[calc(100vh-200px)] overflow-y-auto hide-scrollbar pb-10">
        {initialFormValues !== null && (
          <ImportDocumentForm
            initialValues={initialFormValues}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            title="Update Import Document"
            submitButtonText="Update Import Document"
            loading={loading}
          />
        )}
      </div>
    </Layout>
  )
}

export default ImportDocumentUpdate
